module.exports = __webpack_public_path__ + "static/media/i-beams@2x.255ba632.jpg";